import { SVGIconProps } from "@faire/slate/icons/types";
import { isNotUndefined } from "@faire/typescript";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  Icon: React.FC<SVGIconProps>;
  fontSize?: string;
  titleAccess?: string;
}

export const ButtonIcon: React.FC<IProps> = ({
  titleAccess,
  Icon,
  className,
  fontSize,
  ...props
}) => (
  <div {...props} className={cn(className, "fs-button__icon")}>
    <Icon
      color="inherit"
      {...(isNotUndefined(titleAccess) ? { titleAccess } : {})}
    />
  </div>
);
